import React from 'react';
import { t } from '@lingui/core/macro';

import type { EnhancedPersonSitterProfile } from '@rover/rsdk/src/apiClient/latest/model/enhancedPersonSitterProfile';

import SkillsList from './SkillsList';

const Skills = ({
  catOnlyProfile,
  info,
}: {
  catOnlyProfile: boolean;
  info: EnhancedPersonSitterProfile;
}): JSX.Element | null => {
  if (Object.keys(info.attributes).length === 0) {
    return null;
  }

  // Get cat years of experience if available
  const catYearsOfExperience = info.catProviderProfile?.yearsOfExperience;

  // Create a new info object to avoid mutating the original props
  const attributes = { ...info.attributes };

  // Replace years-of-experience text with catYearsExperienceText for cat-only profiles
  if (catOnlyProfile && attributes['years-of-experience']) {
    attributes['years-of-experience'] = {
      ...attributes['years-of-experience'],
      text: catYearsOfExperience ? t`${catYearsOfExperience} Years of cat care experience` : '',
    };
  }

  return <SkillsList attributes={attributes} />;
};

export default Skills;
